<template>
  <SimpleLayout>
    <ContainerWrapper class="SupportUnavailableContainer">
      <NavBar
        :display-back-button="false"
        @close="$router.push({ path: '/ofertas' })"
      />
      <ContentContainerWrapper>
        <div class="content-wrapper">
          <div class="header">
            <BaseIcon name="negative-artwork" size="lg" />
            <h1>Serviço indisponível</h1>
            <p>
              Nosso atendimento está temporariamente indisponível. Estamos
              trabalhando para restabelecer o serviço o mais breve possível.
            </p>
          </div>
          <div class="footer">
            <Button type="ghost" @click="$router.push('/home')">
              Ir para a Home
            </Button>
          </div>
        </div>
      </ContentContainerWrapper>
    </ContainerWrapper>
  </SimpleLayout>
</template>
<script>
import ContentContainerWrapper from '@/components/ui/newComponents/ContentContainerWrapper.vue'
import NavBar from '@/aasgard/components/navigation/NavBar.vue'
import SimpleLayout from '@/layouts/SimpleLayout.vue'
import ContainerWrapper from '@/components/ui/newComponents/ContainerWrapper.vue'
import Button from '~/aasgard/components/buttons/Button.vue'
import BaseIcon from '~/aasgard/components/base/BaseIcon.vue'
export default {
  name: 'AtendimentoIndisponivelPage',
  components: {
    BaseIcon,
    Button,
    SimpleLayout,
    ContentContainerWrapper,
    NavBar,
    ContainerWrapper,
  },
}
</script>
<style lang="scss">
.SupportUnavailableContainer {
  .content-wrapper {
    position: relative;
    & > .header {
      display: flex;
      flex-direction: column;
      align-items: center;

      & > h1 {
        @include headline-5;
        text-align: center;
        color: $color-black-high;
        margin: 0 0 4px 0;
      }

      & > p {
        @include body-2;
        text-align: center;
        color: $color-black-high;
        margin: 0 0 24px 0;
      }
    }

    & > .content {
      & > .steps {
        background: $color-neutral-light;
        padding: 24px 16px;
      }
    }

    & > .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 40;
      width: 100%;
      padding: 16px;
      background-color: $color-white-high;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
